<div class="product-recap">
  @for (step of cartProduct.steps; track step) {
    <div
      class="flex-column">
      @for (stepCartProduct of step.products; track stepCartProduct) {
        <div>
          <div class="flex-row gap-5">
            <!-- Image -->
            @if (step.step.isImageDisplayEnabled && stepCartProduct.product.image?.fullUrl) {
              <div
                class="product-recap-image"
              [ngStyle]="{'background-image': 'url(\'' + (stepCartProduct.product.image?.fullUrl) + '\')'}"></div>
            }
            <!-- Quantity-->
            @if (stepCartProduct.quantity > 1) {
              <div>
                {{ stepCartProduct.quantity }}x
              </div>
            }
            <!-- Nom produit-->
            <div>{{ stepCartProduct.product.name }}</div>
            <!-- Prix en supplement-->
            @if (stepCartProduct.totalPrice !== 0) {
              <div class="flex-row product-recap-price"
                >
                ({{ stepCartProduct.totalPrice | sign }}<app-price [price]="stepCartProduct.totalPrice"
                [floating]="false"
              [currencyCode]="currencyCode"></app-price>)
            </div>
          }
        </div>
        <app-product-recap [cartProduct]="stepCartProduct"></app-product-recap>
      </div>
    }
  </div>
}
</div>

